<div class="dot-flashing" [class.dark]="isDarkMode"></div>
